import React from 'react'
import { compose } from 'redux'
import injectSheet from 'react-jss'
import { injectIntl } from 'react-intl'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { connect } from 'react-redux'
import _ from 'lodash'
import moment from 'moment'
import helpers from 'helpers'
// import * as basketAction from '../actions/components/basket'

class OrderSummary extends React.Component {
  render () {
    const {
      intl,
      classes,
      merchant,
      orders,
    } = this.props
    const numbersOfCommoditiesPrefix = intl.formatMessage({ id: 'checkout.total_of_front' })
    const numbersOfCommoditiesSuffix = intl.formatMessage({ id: 'checkout.total_of_back' })
    const surchargeText = intl.formatMessage({ id: 'checkout.surcharge' })

    const numbersOfCommodities = orders.length

    const { surchargedTotal, totalSurcharge } = helpers.calculate.calculateOrders(orders, merchant)

    const weekdayIndex = new Date().getDay() // get the index of weekday. 0 = sunday, 1 = monday, etc...
    const defaultSurcharge = _.get(merchant, ['surcharge'], {}) //  default surcharge object with two keys: percent and amount.
    const openingsWithSurcharge = _.get(merchant, ['openingsWithSurcharge'], []) // array of array of objects.

    const periodIndex = _.findIndex(openingsWithSurcharge[weekdayIndex], (period) => {
      const { start, startMin, end, endMin } = period
      const periodStart = moment({ hours: start, minutes: startMin })
      const periodEnd = moment({ hours: end, minutes: endMin })
      if (start + startMin + end + endMin === 0) return true // opening 24 hours (0:0 ~ 0:0)
      if (periodEnd.isBefore(periodStart)) return moment().isBetween(periodStart, periodEnd.add(1, 'day')) // when closing time is earlier than the opening time.
      return moment().isBetween(periodStart, periodEnd, []) // current moment is within the certain time period.
    })

    const surchargePercent = _.get(openingsWithSurcharge, [weekdayIndex, periodIndex, 'surcharge', 'percent'], defaultSurcharge.percent)
    // const surchargeAmount = _.get(openingsWithSurcharge[weekdayIndex][periodIndex], ['surcharge', 'amount'], defaultSurcharge.amount) // never used

    return (
      <div className={classes.orderSummaryContainer}>
        {/** Surcharge */}
        <div className={classes.suchargeSummaryContainer}>
          <div className={classes.surchargeColumn}>{`${surchargeText} (${surchargePercent}%):`}</div>
          <div className={classes.surchargeColumn}>
            <FontAwesomeIcon icon='dollar-sign' />{` ${totalSurcharge}`}
          </div>
        </div>

        {/** Numbers of commodities */}
        <div className={classes.numbersOfCommoditiesContainer}>{`${numbersOfCommoditiesPrefix} ${numbersOfCommodities} ${numbersOfCommoditiesSuffix}`}</div>

        {/** Total Amount */}
        <div className={classes.totalAmountContainer}>
          <FontAwesomeIcon className={classes.totalAmountDolorSign} icon='dollar-sign' />
          <span className={classes.totalAmont}>{` ${surchargedTotal}`}</span>
        </div>
      </div>
    )
  }
}

// Jss
const styles = {
  orderSummaryContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'center',
    color: '#A59996',
    paddingBottom: 16,
  },
  suchargeSummaryContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: '100%',
    padding: '8px 0px',
    margin: '8px 0px',
    borderBottom: '1px solid #efefef',
    '& div:last-child': {
      marginLeft: 40,
    },
  },
  surchargeColumn: {
    textAlign: 'right',
    fontSize: 12,
  },
  numbersOfCommoditiesContainer: {
    width: '100%',
    textAlign: 'right',
  },
  totalAmountContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginTop: 3,
  },
  totalAmont: {
    color: '#614D4A',
    fontSize: 22,
    fontWeight: 'bold',
    letterSpacing: 1,
    textAlign: 'left',
    marginLeft: 3,
  },
  totalAmountDolorSign: {
    color: '#614D4A',
    fontSize: 12,
    fontWeight: 'bold',
  },
}

const mapStateToProps = (state) => {
  return {
    merchant: state.merchant,
  }
}

const mapDispatchToProps = {
  // getBasket: basketAction.getBasket,
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectSheet(styles),
  injectIntl,
)(OrderSummary)



// WEBPACK FOOTER //
// ./src/components/OrderSummary.js